// extracted by mini-css-extract-plugin
export default {"root":"Vote_root__QixwW","main":"Vote_main__ZvyRb","spin":"Vote_spin__DbiJi"};